import React from 'react';

import { AtlassianIcon } from '@atlaskit/logo';

const LogoSmall = (): React.JSX.Element => {
	return <AtlassianIcon size="small" appearance="brand" />;
};

export default LogoSmall;
